import { LinkOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'
import { isHttpUrl } from '@eastcoal/common/utils/url'

import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const SwitchUrlButton = () => {
  const {
    url,
    text,
    icon,
    syncFormData,
    updateLinkNode,
    toggleToolbarVisible
  } = useLinkCardStore(state =>
    pick(state, [
      'url',
      'text',
      'icon',
      'syncFormData',
      'updateLinkNode',
      'toggleToolbarVisible'
    ])
  )

  const handleShowUrl = () => {
    toggleToolbarVisible(false)

    if (!url) {
      return
    }

    syncFormData({
      text: url,
      icon: undefined
    })

    updateLinkNode()
  }

  // url 不存在
  // icon 不存在并且 text 已经是 http 链接
  const disabled = !(url && url.trim()) || (!icon && isHttpUrl(text))

  return (
    <MenuButton disabled={disabled} tooltip='显示链接' onClick={handleShowUrl}>
      <LinkOutlined />
    </MenuButton>
  )
}
